import React from 'react';
import SectionTitle from '../../elements/section-title/SectionTitle';
import ServicePropFour from '../service/ServicePropFour';
import SEOServicesData from "../../data/seo/SEOServicesData.json"

const SEOSwevicesShowcase = () => {
    return (
        <div className="section section-padding bg-color-dark" style={{ position: 'relative', overflow: 'hidden' }}>
            <div className="container">
                <SectionTitle
                    subtitle="What We Can Do For You"
                    title="Services we can help you with"
                    textAlignment="heading-center heading-light"
                    textColor=""
                    paragraphClass="d-none"
                />

                {/* Wrapper for 2-column layout */}
                <div className="row mt-5 seo-services-grid-wrapper">
                    <ServicePropFour
                        serviceData={SEOServicesData}
                        colSize="col-lg-6 col-md-12"
                        serviceStyle="service-style-4"
                    />
                </div>
            </div>

            {/* Decorative background elements */}
            <ul className="list-unstyled shape-group-10">
                <li className="shape shape-1">
                    <img src={process.env.PUBLIC_URL + "/images/others/line-9.png"} alt="Circle" />
                </li>
                <li className="shape shape-2">
                    <img src={process.env.PUBLIC_URL + "/images/others/bubble-42.png"} alt="Circle" />
                </li>
                <li className="shape shape-3">
                    <img src={process.env.PUBLIC_URL + "/images/others/bubble-43.png"} alt="Circle" />
                </li>
            </ul>

            <style jsx>{`              
                .seo-services-grid-wrapper .title,
                .seo-services-grid-wrapper .title {
                    color: #ffffff;
                }
            `}</style>
        </div>
    );
};

export default SEOSwevicesShowcase;